import { Modal } from 'components/Structures'
import { Worker, Viewer } from '@react-pdf-viewer/core'
import '@react-pdf-viewer/core/lib/styles/index.css'
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout'
import '@react-pdf-viewer/default-layout/lib/styles/index.css'
import { Dispatch, SetStateAction, useEffect } from 'react'

import * as S from './style'

type ModalPreviewPdfProps = {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  handleClose?: () => void
  title: string | JSX.Element
  fileUrl: string
}

export const ModalPreviewPdf = ({
  open,
  setOpen,
  handleClose,
  title,
  fileUrl
}: ModalPreviewPdfProps) => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin()

  useEffect(() => {
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setOpen(false)
      }
    }
    window.addEventListener('keydown', handleEsc)

    return () => {
      window.removeEventListener('keydown', handleEsc)
    }
  }, [])

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      closeAction={handleClose}
      title={title}
      showClose={true}
    >
      <S.Container>
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
          <Viewer fileUrl={fileUrl} plugins={[defaultLayoutPluginInstance]}></Viewer>
        </Worker>
      </S.Container>
    </Modal>
  )
}
